<template>
  <div class="produts">
    <div class="produts-title">
      <custom-breadcrumb/>
    </div>
    <div class="produts-search">
      <el-form :inline="true" :model="produtsForm">
        <el-form-item>
          <el-select placeholder="Category" v-model="produtsForm.categoryId" clearable @change="search">
            <el-option
              v-for="(item,index) in categorysList"
              :key="index"
              :label="item.cateName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="produtsForm.time"
            value-format="yyyy-MM-dd"
            format="MM.dd.yyyy"
            type="date"
            placeholder="Last Update"
            @change="search"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="Product name / Brands/Product ID" v-model="produtsForm.keyWords"
                    class="input-with-select" style="width: 550px;" clearable @clear="handleClearKeyWords">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <div class="produts-search-button" slot="append" @click="search">
              Search
            </div>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="products-content">
      <el-table
        ref="data-table"
        :data="tableData"
        stripe
        style="width: 100%;min-height: calc(100vh - 400px);margin-bottom:90px"
        @cell-mouse-enter="handleMouseEnter"
        @cell-mouse-leave="handleMouseLeave"
      >
        <el-table-column label="Name" min-width="350">
          <template slot-scope="scope">
            <div class="table-name">
              <div class="table-img"><img :src="scope.row.imgPath" alt=""></div>
              <div>
                {{ scope.row.skuName }}
              </div>
            </div>

          </template>
        </el-table-column>
        <el-table-column
          prop="categroyName"
          min-width="100"
          label="Category"
        >
        </el-table-column>
        <el-table-column
          min-width="180"
          label="Wholesale Cost Price($)"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.wholesaleCostPrice ? '$' + scope.row.wholesaleCostPrice : '——' }}</div>
          </template>
        </el-table-column>

        <el-table-column
          min-width="160"
          label="Wholesale Price($)"
          column-key="uid"
        >
          <template slot-scope="scope">
            <div>
              <el-input style="width: 70px"
                        oninput="
                if(value){value=value.replace(/[^0-9.]/g,'')}
                if(value){value=value.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')}"
                        @change="handleUpdatePrice(scope.row)"
                        v-model="scope.row.wholesalePrice"
                        v-if="scope.$index === wholesaleEditIndex"
              >
              </el-input>
              <span v-if="scope.$index !== wholesaleEditIndex">
                {{ scope.row.wholesalePrice ? '$' + scope.row.wholesalePrice : '——' }}
              </span>
              <el-button type="text" @click="handleClickEdit(scope.$index)"
                         style="color: #000000;font-weight:600;margin-left: 5px;"
                         v-if="scope.row['wholesalePriceDisplay'] === 1">Edit
              </el-button>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          min-width="180"
          label="Shipping from Country"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.shippingFromCountry ? scope.row.shippingFromCountry : '——' }}</div>
          </template>
        </el-table-column>


        <el-table-column
          min-width="150"
          label="Inventory"
        >
          <template slot-scope="scope">
            <span @click="handleInventory(scope.row)" class="table-url"

            >
              {{ scope.row.num }}
            </span>

          </template>
        </el-table-column>

        <el-table-column
          min-width="120"
          prop="brandName"
          label="Brand"
        >
        </el-table-column>
        <el-table-column
          min-width="120"
          prop="updateAtStr"
          label="Last Update"
        >
        </el-table-column>


        <el-table-column
          min-width="150"
          label="Product Link"
        >
          <template slot-scope="scope">
            <span @click="openUrl(scope)" class="table-url">View</span>
          </template>
        </el-table-column>

      </el-table>
    </div>
    <div class="page_table" v-if="tableData.length>0">
      <pagination
        :currentPage="paging.current"
        :total="paging.total"
        :pageSize="paging.size"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      />
    </div>
  </div>

</template>

<script>
import Pagination from '../components/pagination.vue'
import {getAction, putAction} from '@/api/manage.js'

import CustomBreadcrumb from '../components/custom-breadcrumb'

export default {
  name: 'procurement-products',
  components: {CustomBreadcrumb, Pagination},
  data() {
    return {
      produtsForm: {
        pageSize: 20,
        pageNo: 1,
        startDateValue: '',
        endDateValue: '',
        keyWords: ''
      },
      categorysList: [],
      tableData: [],
      paging: {},
      wholesaleEditIndex: null
    }
  },
  methods: {
    handleMouseEnter(row) {
      row['wholesalePriceDisplay'] = 1
    },
    handleMouseLeave(row) {
      row['wholesalePriceDisplay'] = 0
      this.wholesaleEditIndex = null
    },
    handleClickEdit(index) {
      this.wholesaleEditIndex = index
    },

    async search() {
      if (this.produtsForm.time) {
        this.produtsForm.startDateValue = this.produtsForm.time + ' 00:00:00'
        this.produtsForm.endDateValue = this.produtsForm.time + ' 23:59:59'
      } else {
        this.produtsForm.startDateValue = ''
        this.produtsForm.endDateValue = ''
      }
      let data = await getAction(`v0.2/brand/procurement/sku-list`, this.produtsForm)
      if (data.code === 200) {
        this.tableData = data.result.records.map(e => {
          e['wholesalePriceDisplay'] = 0
          return e
        })
        this.paging = data.result
      }
    },
    handleSizeChange(val) {
      this.produtsForm.pageSize = val
      this.produtsForm.pageNo = 1
      this.search()
    },
    handleCurrentChange(val) {
      this.produtsForm.pageNo = val
      this.search()
    },
    openUrl(obj) {
      let env = process.env.NODE_ENV
      let url = ''
      env === 'test' ? url = 'https://test-thalesmart-manage-ui2.hupofintech.com/product'
        : url = 'https://www.shopvidi.com/product'
      window.open(url + obj.row.seoUrl)
    },
    handleUpdatePrice(row) {
      row.wholesalePrice = row.wholesalePrice || 0
      row['wholesalePriceDisplay'] = 0
      putAction(`v0.2/brand/procurement/${row.id}/update-price?wholesalePrice=${row.wholesalePrice}`).then(async res => {
        if (res.code === 200) {
          await getAction(`/es/createGoods?goodsId=${row.spuId}`)
        } else {
          this.$message.error(res.messages())
        }
      }).catch(() => {
      })
    },
    handleInventory(row) {
      this.$router.push(`procurement-sku-inventory?id=${row.skuId}`)
    },
    handleClearKeyWords() {
      this.produtsForm.keyWords = ''
      this.search()
    }
  },

  async created() {
    let categorys = await getAction('/sp/suppliers/wholesales-categorys')
    if (categorys.code === 200) {
      this.categorysList = categorys.result
    }
    await this.search()
  }
}
</script>

<style lang="less" scoped>
.page_table {
  background: #FFFFFF;
  width: 100%;
  position: fixed;
  bottom: 0px;
  z-index: 2;
}

/deep/ .el-input-group__append {
  background: #000000;
  color: #ffffff;

  :hover {
    cursor: pointer;
  }
}

/deep/ .cell {
  font-size: 14px;
  font-family: Avenir;
  font-weight: 500;
  color: #000000;
}

.table-name {
  display: flex;

  div:nth-child(2) {
    padding-left: 10px;
  }

}

.review-mark {
  width: 120px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #C3824B;
  border: 1px solid #E1E1E1;
  background: #E1E1E1;
  border-radius: 5px;
}

.table-img {
  max-width: 80px;
  max-height: 80px;
  border: 1px solid #262B2F;

  img {
    width: 100%;
    height: 100%;
  }

}

.produts {
  .produts-title {
    font-size: 14px;
    font-family: Graphik;
    font-weight: 600;
    color: #262B2F;
    padding-bottom: 20px;
  }

  // padding-left: 31px;
  padding-right: 53px;
}

.produts-top {
  width: 100%;
  padding-top: 10px;
  border-bottom: 1px solid #E1E1E1;
  position: relative;

  .produts-top-tabs {
    width: 348px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    font-family: Graphik;
    font-weight: 400;
    color: #5D5D5D;

    div {
      width: 116px;
      text-align: center;
      cursor: pointer;
    }

    .isActive {
      padding-bottom: 17px;
      border-bottom: 2px solid #262B2F;
      font-size: 16px;
      font-family: Graphik;
      font-weight: 500;
    }

  }

  .btn-add-product {
    box-sizing: border-box;
    position: absolute;
    background: #000000;
    color: #ffffff;
    width: 150px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    right: 0px;
    top: 0px;
    cursor: pointer;
  }
}

.produts-search {
  padding-top: 24px;
}

.table-url {
  cursor: pointer;
  text-decoration: underline;
}

.edit {
  width: 80px;
  height: 40px;
  line-height: 40px;
  background: #000000;
  color: #ffffff;
  text-align: center;
  border-radius: 12px;
  cursor: pointer;
}

// .produts-search-button{
//   background: #000000;
// }

.cust-active {
  /deep/ .el-select {
    width: 90px;
    height: 40px;
    opacity: 1;
    border-radius: 20px;
  }

  /deep/ .el-input__inner {
    border-radius: 20px !important;
  }

  .normal {
    /deep/ .el-input__inner {
      background: #262613 !important;
      color: #ffffff;
    }
  }

  /deep/ .el-dropdown {
    height: 20px;
    background: #f4f4f4 !important;
    border: 1px solid #e1e1e1;
    border-radius: 20px;
    line-height: 40px;
  }
}

.review {
  span {
    width: 80px;
    border: 20px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border: 1px #262613 solid;
    border-radius: 20px;
    display: inline-block;
    cursor: pointer;

  }
}

</style>



// WEBPACK FOOTER //
// src/pages/wholesale/procurement-products.vue